//混入方法,定义通用方法
const mixinModel = {
  data() {
    return {

    }
  },
  computed: {
    userModel() {
      return this.$store.state.userModel;
    },

  },
  props: {
    // 审核嵌入页面传入的guid的值
    serviceGuid: {
      type: String,
      default: ''
    },
    // 当前页面是否可以编辑，0-不可编辑，1-可编辑,默认为可编辑
    serviceEdit: {
      type: Number,
      default: 1
    },
    serviceQuery: {
      type: Object,
      default:function(){
        return {}
      }
    },
  },
  methods: {
    Back() {
      let that = this

      //从params或者backUrl里拿到参数
      let backUrl = that.$route.params.backUrl ? that.$route.params.backUrl : that.$route.query.backUrl
      this.$router.push(backUrl)
    },
    Resize(){
      
    }
  },
}

export default mixinModel
